export const TASK_FILTER_CONSTANTS = {
	OPEN: 'OPEN',
	DUE_TODAY: 'DUE_TODAY',
	DUE_THIS_WEEK: 'DUE_THIS_WEEK',
	OVERDUE: 'OVERDUE',
	DONE: 'DONE',
};
